import { ReactElement } from "react";
import HubsList from "../../components/Hubs";
import Layout from "../../components/layout";

const HubsPage = (): ReactElement => {
  return (
    <Layout>
      <HubsList />
    </Layout>
  );
};

export default HubsPage;
